// extracted by mini-css-extract-plugin
export default {"singleEntry":"_2jJD6","selectedEntry":"MtqVB","entryName":"_9brf8","selected":"_3y_Si","stakeNameContainer":"_1arMP","maxWinning":"_1TVhZ","amount":"_7QpI6"};